import Vue from 'vue'
import store from '@/store'

Vue.prototype.$loading = (show, message = 'Aguarde...') => {
  store.dispatch('setLoading', { show, message })
}
